module.exports = __webpack_public_path__ + "static/media/demand.e8ac78e1.png";